import React from 'react';
import { withTranslation } from 'react-i18next';
import Icon from '../../../../../../../../components/icon/index';
import {connect} from 'react-redux';
import axios from "axios";
import {Trans} from 'react-i18next';
import {API_ROOT} from '../../../../../../../../utils';
import InvalidSharingPopupMessage from "../../../../../sharing-details-popup/components/invalid-sharing-popup-message";
import {
    getSharingDetailsLv2Popup
} from "../../../../../../../../../actions/sharingDetailsActions";
import Button from '../../../../../../../../components/button';
import "./index.css";
import {findLabels} from "../../../../../../../../../actions/contactsGroupItemActions";

class StatusDescription extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            emailResent: false,
            displayStatusFilter: false,
			error: null,
            isProcessFollowed: false,
            isSyncing: false,
        };

        this.closePopup = this.closePopup.bind(this);
        this.resend = this.resend.bind(this);
        this.copyLinkHandler = this.copyLinkHandler.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount(){
    	if(this.props.sharingDetailsLv2Popup[2] === "invitationPending" || this.props.sharingDetailsLv2Popup[2] === "invitationWarning"){
            axios.get(API_ROOT + '/invited/link?targetId=' + (this.props.sharingDetailsLv2Popup[3] !== undefined ? this.props.sharingDetailsLv2Popup[3] : '')).then(response => {
                document.getElementById("invitationCode").value = response.data.link;
            })
		}
    }

    windowCloseIfGmailAddOnPopup = () => {
        if(this.props.checkGAddon ==='gmailaddon'){
            window.close();
        }
    };

    handleCheck(e){

        if(e.currentTarget.checked) {
            this.setState({
                isProcessFollowed: true
            });
        } else {
            this.setState({
                isProcessFollowed: false
            });
        }

    }

    handleSync(e){

        e.preventDefault();

        this.setState({
            isSyncing: true
        }, () => {
            setTimeout(() => {
                this.props.getSharingDetailsLv2Popup([]);
                this.props.setFindLabels(this.props.labelsPageSize, true);
            }, 2000)
        });
    }

    closePopup(){
        this.props.getSharingDetailsLv2Popup([]);
	}

    copyLinkHandler(){
    	document.getElementById("invitationCode").select();
        document.execCommand('copy');
	}

	resend(){
		axios.post(API_ROOT + '/v9/api/resend-email', {
            "ownerId": this.props.profile.id,
            "targetId": this.props.sharingDetailsLv2Popup[3],
            "groupIds": [this.props.selectedContactsGroup.id]
		},{withCredentials: true}).then(response => {
			if(response.status === 200){
				this.setState({
                    emailResent: true
				});
                this.props.getSharingDetailsLv2Popup([]);
			}
		}).catch(e => {
            this.setState({
                error: e
            });
		})
	}

	render() {
		switch (this.props.sharingDetailsLv2Popup[2]) {
			case 'invitationPending':
				return (
					<div className="invitation-pending-popup p-4">
						<h2><Icon name="clock-o" className="text-warning"/> <span className="text-warning">{this.props.t("InviteSentText")}</span></h2>
						<p>
                        <Trans i18nKey="invitationPopup" values={{email_id:  this.props.sharingDetailsLv2Popup[3]}}  />
                        </p>
                        <p>{this.props.t("resendInviteText1")}</p>
						<div className="text-center">
                            <Button onClick={this.resend} className="btn-default">{this.props.t("ressendInviteText2")}</Button>
						</div>
                        <div className="position-relative">
                            <hr className="my-4" />
							<div className="or">{this.props.t("orText")}</div>
                        </div>
                        <p>{this.props.t("inviteDirectLinkText")}</p>
                        <div className="position-relative mb-3">
                            <input id="invitationCode" className="form-control invitation-code" type="text" defaultValue={"Loading …"}/>
                            <Button onClick={this.copyLinkHandler} className="copy-link btn-link position-absolute">{this.props.t("copyText")}</Button>
                        </div>
						{
							this.state.emailResent
							?
                                <div className="alert alert-success mt-4 px-3">
                                   <Icon name={"check"} className="text-success mr-2" /> {this.props.t("textDescriptionEmailSent")}
                                </div>
							:
								null
						}
                        {
                            this.state.error !== null
                                ?
                                <div className="alert alert-danger mt-4 px-3">
                                    <Icon name={"check"} className="text-danger mr-2" /> {this.props.t("textErrorOccured")} {this.state.error}.
                                </div>
                                :
                                null
                        }
					</div>
				);
			case 'invitationWarning':
                return (
                    <div className="invitation-pending-popup p-4">
                        <h2><Icon name="warning" className="text-danger"/> <span className="text-danger">Invitation sent</span></h2>
						<p><Trans i18nKey="inviteSentNotAcceptedText1" values={{email_id:  this.props.sharingDetailsLv2Popup[3]}}  /></p>
                        <p>{this.props.t("resendInviteText1")}</p>
                        <div className="text-center">
                            <Button onClick={this.resend} className="btn-default">{this.props.t("ressendInviteText2")}</Button>
                        </div>
                        <div className="position-relative">
                            <hr className="my-4" />
                            <div className="or">{this.props.t("orText")}</div>
                        </div>
                        <p>{this.props.t("inviteDirectLinkText")}</p>
                        <div className="position-relative mb-3">
                            <input id="invitationCode" className="form-control invitation-code" type="text" defaultValue={"Loading …"}/>
                            <Button onClick={this.copyLinkHandler} className="copy-link btn-link position-absolute">{this.props.t("copyText")}</Button>
                        </div>
                        {
                            this.state.emailResent
                                ?
                                <div className="alert alert-success mt-4 px-3">
                                    <Icon name={"check"} className="text-success mr-2" /> {this.props.t("textDescriptionEmailSent")}
                                </div>
                                :
                                null
                        }
                        {
                            this.state.error !== null
                                ?
                                <div className="alert alert-danger mt-4 px-3">
                                    <Icon name={"check"} className="text-danger mr-2" /> {this.props.t("textErrorOccured")} {this.state.error}.
                                </div>
                                :
                                null
                        }
                    </div>
                );
			case 'suspended':
				return (
                    <InvalidSharingPopupMessage error="USER_SUSPENDED" close={this.closePopup} />
				);
			case 'licenseLimitReached':
				return (
                    <InvalidSharingPopupMessage error="LICENSES_LIMIT" close={this.closePopup} />
				);
			case 'partiallyShared':
				return (
                    <div className="p-4">
						<h2><Icon name="chain-broken" className="text-warning"/> <span className="text-warning">{this.props.t("partiallySharedText")}</span></h2>
						<p>{this.props.t("textStatusDescriptionPartiallyShared4")}</p>
						<ul>
							<li>{this.props.t("expiredLincencesText1")}</li>
							<li>{this.props.t("textStatusDescriptionPartiallyShared3")}</li>
							<li>{this.props.t("textStatusDescriptionPartiallyShared2")}</li>
							<li>{this.props.t("textStatusDescriptionPartiallyShared1")}</li>
						</ul>
					</div>
				);
			case 'revoked':
				return (
                    <InvalidSharingPopupMessage error="USER_IS_REVOKED" close={this.closePopup} resend={this.resend} />
				);
			case 'overQuota':
				return (
                    <div className="p-4">
						<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">{this.props.t("OverQuotaText")}</span></h2>
						<p>
                            {this.props.t("textStatusDescriptionOverQuota2")}<br/>
                            <Trans i18nKey="textOverQuotaContent" components={{a: <a href= 'https://www.getsharedcontacts.com/knowledge-base/how-to-solve-contact-limit-reached-in-google-contacts/'> </a>}} />
                        </p>
                        <div className="form-check mb-2">
                            <input onClick={this.handleCheck} className="form-check-input" type="checkbox" id="isResold" name="isResold"/>
                            <label className="form-check-label" htmlFor="isResold">
                                {this.props.t("textStatusDescriptionOverQuota1")}
                            </label>
                        </div>
                        <div className="text-right">
                            {
                                this.state.isSyncing === false
                                ?
                                    <Button disabled={this.state.isProcessFollowed === false} onClick={this.handleSync} className="btn-primary">{this.props.t("textSync")}</Button>
                                :
                                    <Button disabled={true} className="btn-primary">
                                        <Icon animated={'pulse'} name="spinner"/>
                                    </Button>
                            }

                        </div>
					</div>
				);
			case 'deleted':
				return (
                    <InvalidSharingPopupMessage error="USER_IS_DELETED" close={this.closePopup} />
				);
			case 'banned':
				return (
                    <InvalidSharingPopupMessage error="USER_IS_BANNED" close={this.closePopup} />
				);
			case 'upgradeNow':
				return (
					<div className="p-4">
						<h2><Icon name="level-up" className="text-danger"/> <span className="text-danger">{this.props.t("textUpgradeTitle")}</span></h2>
						<p dangerouslySetInnerHTML={{__html:this.props.t('textUpgradeContent', { plan_name: this.props.profile.domain.plan })}}/>
						<hr/>
						<h3>{this.props.t("textUpgradeContent8")}</h3>
						<p><Trans i18nKey="textUpgradeContent9" values={{plan_name:"Business"}}/></p>
						<div className="text-right">
							<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/api/payment/upgrade`} onClick ={this.windowCloseIfGmailAddOnPopup} target="_blank" rel="noreferrer">{this.props.t("textUpgradeNow")}</a>
						</div>
					</div>
				);
			case 'unknown':
				return (
                    <div className="p-4">
						<h2><Icon name="question-circle-o" className="text-danger"/> <span className="text-danger">{this.props.t("unknownCollaboratorText")}</span></h2>
						<p>{this.props.t("unknownCollaboratorPopupText")}</p>
					</div>
				);
			case 'contactLimitReached':
				return (
					<div className="p-4">
						<h2><Icon name="level-up" className="text-danger"/> <span className="text-danger">{this.props.t("textUpgradeTitle")}</span></h2>
						<p dangerouslySetInnerHTML={{__html:this.props.t('textUpgradeContent', { plan_name: this.props.profile.domain.plan })}}/>
						<hr/>
						<h3>{this.props.t("textUpgradeContent8")}</h3>
						<p><Trans i18nKey="textUpgradeContent9" values={{plan_name:"Business"}}/></p>
						<div className="text-right">
							<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/api/payment/upgrade`} onClick ={this.windowCloseIfGmailAddOnPopup} target="_blank" rel="noreferrer">{this.props.t("textUpgradeNow")}</a>
						</div>
					</div>
				);
			default:
				return (
                    <div className="p-4">
						¯\_(ツ)_/¯
					</div>
				)
		}
	}
}

const mapStateToProps = (state) => {
	return {
		profile : state.profileReducer.getProfile,
		selectedContactsGroup : state.contactsGroupItemReducer.getSelectedContactsGroup,
        sharingDetailsLv2Popup: state.sharingDetailsReducer.getSharingDetailsLv2Popup,
        labelsPageSize : state.contactsGroupItemReducer.labelsPageSize,
        checkGAddon: state.profileReducer.setGmailAddOnData.checkGmailAddon,
	};
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSharingDetailsLv2Popup: (array) => {
            dispatch(getSharingDetailsLv2Popup(array))
        },
        setFindLabels : (pageSize, directLaunch) => {
            dispatch(findLabels(pageSize, directLaunch))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StatusDescription));
